import React from 'react';

export const MapStyleDetails = () => (
  <svg viewBox="0 0 146 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="-152.603" y="-37.9714" width="305.603" height="172.121" fill="url(#pattern0)" />
    <path
      d="M59.9573 -11.6277C44.5563 3.07337 66.5746 17.1781 73.3363 24.6686C78.9101 30.8432 105.509 25.9812 101.014 12.1169C99.3745 7.0603 125.523 -2.31694 123.639 -7.12243"
      stroke="#BF8F00"
      strokeWidth="3.5"
    />
    <path
      d="M59.9573 -11.6277C44.5563 3.07337 66.5746 17.1781 73.3363 24.6686C78.9101 30.8432 105.509 25.9812 101.014 12.1169C99.3745 7.0603 125.523 -2.31694 123.639 -7.12243"
      stroke="#FFF359"
      strokeWidth="3.5"
    />
    <path
      d="M19.3398 -2.91333C32.9176 9.70681 51.0046 14.1953 61.5085 30.1153C76.7701 53.2461 75.2784 71.5115 71.5371 95.4964C70.2466 103.769 83.0437 100.581 85.3697 95.4964C89.9972 85.3798 84.354 75.2435 90.2041 65.7813C96.6564 55.3452 106.951 47.8447 115.325 38.8765C117.55 34.0843 122.9 23.5 126.5 19.5C131 14.5 141.5 0.67334 147 -2.91333"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M19.3398 -2.91333C32.9176 9.70681 51.0046 14.1953 61.5085 30.1153C76.7701 53.2461 75.2784 71.5115 71.5371 95.4964C70.2466 103.769 83.0437 100.581 85.3697 95.4964C89.9972 85.3798 84.354 75.2435 90.2041 65.7813C96.6564 55.3452 106.951 47.8447 115.325 38.8765C118.383 32.751 124.9 20.2 126.5 19C128.5 17.5 139 5 141 3C142.6 1.4 146.333 -1.60889 148 -2.91333"
      stroke="#999999"
      strokeLinejoin="round"
      strokeDasharray="3 2"
    />
  </svg>
);
